const MIRRORED_PROPERTIES = [
	"direction",
	"boxSizing",
	"width",
	"overflowX",
	"overflowY",
	"borderTopWidth",
	"borderRightWidth",
	"borderBottomWidth",
	"borderLeftWidth",
	"borderStyle",
	"paddingTop",
	"paddingRight",
	"paddingBottom",
	"paddingLeft",
	"fontStyle",
	"fontVariant",
	"fontWeight",
	"fontStretch",
	"fontSize",
	"lineHeight",
	"fontFamily",
	"textAlign",
	"textTransform",
	"textIndent",
	"textDecoration",
	"letterSpacing",
	"wordSpacing",
	"tabSize",
] as const satisfies readonly (keyof CSSStyleDeclaration)[];

export interface CaretCoordinates {
	top: number;
	left: number;
	height: number;
}

/**
 * Textareas don't expose caret pixel position natively. This renders an
 * invisible mirror div with identical text-flow styling, splits the text at
 * `position`, and measures where the split lands.
 */
export const getCaretCoordinates = (
	textarea: HTMLTextAreaElement,
	position: number,
): CaretCoordinates => {
	const div = document.createElement("div");
	document.body.appendChild(div);

	const computed = window.getComputedStyle(textarea);
	const style = div.style;

	style.position = "absolute";
	style.visibility = "hidden";
	style.whiteSpace = "pre-wrap";
	style.wordWrap = "break-word";

	MIRRORED_PROPERTIES.forEach((prop) => {
		style[prop] = computed[prop];
	});

	div.textContent = textarea.value.slice(0, position);

	const span = document.createElement("span");
	span.textContent = textarea.value.slice(position) || ".";
	div.appendChild(span);

	const coordinates: CaretCoordinates = {
		top: span.offsetTop + parseFloat(computed.borderTopWidth) - textarea.scrollTop,
		left: span.offsetLeft + parseFloat(computed.borderLeftWidth) - textarea.scrollLeft,
		height: span.offsetHeight,
	};

	document.body.removeChild(div);

	return coordinates;
};
